import { AfterViewInit, Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { AuthUtil } from '@app/common/util/auth.util';
import { ValidationUtil } from '@app/common/util/validation.util';
import { SmWownetModel } from '@app/models/system/sm-wownet.model';
import { getSmWownet, SmWownetState } from '@app/selectors/system/sm-wownet.selector';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';

declare const handleDecorElements: any;

@Component({
    selector: 'app-home-page',
    templateUrl: './home-page.component.html',
    styleUrls: ['./home-page.component.css']
})

export class HomePageComponent implements OnInit  {
    @ViewChild('videoElement') videoElement!: ElementRef;
    smWownet$ = new Observable<SmWownetModel>;

    urlWownet: string = "";
    lMemRegYn: string = "";
    lshowPdtYn: string = "";
    
    isLogined: boolean = AuthUtil.isLogined();
    
    constructor(
        private _smWownetStateStore: Store<SmWownetState>
    ) {
        this.smWownet$ = this._smWownetStateStore.select(getSmWownet);
    }

    ngOnInit(): void {
        this.smWownet$.subscribe(res => {
            if (ValidationUtil.isNotNullAndNotEmpty(res)) {
                this.lMemRegYn = res.lMemRegYn;
                this.urlWownet = res.urlWownet;
                this.lshowPdtYn = res.lShowPdtYn;
            }
        });

        handleDecorElements();
    }

    ngAfterViewInit() {
        const video = this.videoElement.nativeElement;
    
        // Play the video muted
        video.muted = true;
        video.play();
    
        // Add an event listener to detect user interaction (click)
        document.addEventListener('click', () => {
          // Unmute the video after user interaction
          video.muted = false;
          // Play the video again, now with sound
          video.play();
    
          video.addEventListener('ended', () => {
            console.log('Video has ended');
            // You can perform actions here, like showing a replay button or advancing to the next video
          });
        }, { once: true }); // Remove the event listener after it's triggered once
    }
}
